import { EventTypes } from './EventTypes';

export class StineEvent<T> {
  public type: EventTypes;
  public data: T;
  constructor(type: EventTypes, data: T = null as any) {
    this.type = type;
    this.data = data;
  }
}
